(function () {
	'use strict';
	$(document).ready(function () {

		$(document).on('click', 'input[name="rf-radio"]', function (e) {
			let value = (this).value;
			$('.company, .additional').hide();
			$('.organization').show();

			function replaceText(param) {
				$('label[for="rf-name"]').html(param.rf_name);
				$('label[for="rf-email"]').html(param.rf_email);
				$('label[for="rf-place"]').html(param.rf_place);
				$('label[for="rf-introduce"]').html(param.rf_introduce);
				$('label[for="rf-idea"]').html(param.rf_idea);
				$('label[for="rf-have"]').html(param.rf_have);
				$('label[for="rf-support"]').html(param.rf_support);
			}


			switch (value) {
				case 'Osoba prywatna':
					replaceText(privacy);
					break;
				case 'Grupa nieformalna':
					replaceText(group);
					break;
				case 'Organizacja społeczna':
				case 'Firma':
				case 'Inna': {
					replaceText(organization);
					$('.company').css('display', 'flex');
					$('.organization').hide();
					$('.additional').show();


					break;
				}
			}
		});

		$('#save').on('click', function () {
			localStorage.clear();
			$('input, textarea').each(function (e) {
				var input = $(this);
				localStorage.setItem(input.attr('name'), input.val());
				if (input.is(':checked')) {
					localStorage.setItem(input.attr('name'), 'set');
				}
			});
			localStorage.setItem('rf-radio', document.querySelector('input[name="rf-radio"]:checked').value);
		});

		$('input[type="text"],input[type="email"], textarea').each(function (e) {
			var input = $(this);
			if (localStorage.getItem(input.attr('name'))) {
				input.val(localStorage.getItem(input.attr('name')));
			}
		});

		$('input[type="radio"]').each(function (e) {
			var input = $(this);
			if (localStorage.getItem('rf-radio') === input.val()) {
				input.prop('checked', true);
				input.click();
			}
		});


		$('.choices').on('click', function () {

			$('.new, .enhanc, .inst, .add-fields').hide();

			if ($('#rf-enhanc').is(':checked')) {
				$('.add-fields').show();
				$('.enhanc').css('display', 'flex');
			}
			if ($('#rf-inst').is(':checked')) {
				$('.add-fields').show();
				$('.inst').css('display', 'flex');
			}
			if ($('#rf-new').is(':checked')) {
				$('.add-fields').show();
				$('.new').css('display', 'flex');
			}

		});

		$('input[type="checkbox"]').each(function (e) {
			var input = $(this);
			if (localStorage.getItem(input.attr('name')) === 'set') {
				input.prop('checked', true);
			}
			$('.choices').click();
		});

		function sendReportForm() {

			var data = new FormData();

			data.append('who', $('input[name=rf-radio]:checked').val());
			data.append('other', $('input[name=rf-other]').val());
			data.append('company', $('input[name=rf-companyName]').val());
			data.append('name', $('input[name=rf-name]').val());
			data.append('email', $('input[name=rf-email]').val());
			data.append('phone', $('input[name=rf-phone]').val());
			data.append('place', $('input[name=rf-place]').val());
			data.append('introduce', $('textarea[name=rf-introduce]').val());
			data.append('idea', $('textarea[name=rf-idea]').val());
			data.append('have', $('textarea[name=rf-have]').val());
			data.append('support', $('textarea[name=rf-support]').val());

			data.append('ineed', $('textarea[name=rf-ineed]').val())
			data.append('eproject', $('textarea[name=rf-eproject]').val());
			data.append('ehave', $('textarea[name=rf-ehave]').val());
			data.append('esupport', $('textarea[name=rf-esupport]').val());
			data.append('eidea', $('textarea[name=rf-eidea]').val());

			data.append('nproject', $('textarea[name=rf-nproject]').val());
			data.append('nhave', $('textarea[name=rf-nhave]').val());
			data.append('nsupport', $('textarea[name=rf-nsupport]').val());
			data.append('nidea', $('textarea[name=rf-nidea]').val());

			data.append('new', $('input[name=rf-new]:checked').val() || 0);
			data.append('inst', $('input[name=rf-inst]:checked').val() || 0);
			data.append('enhanc', $('input[name=rf-enhanc]:checked').val() || 0);

			data.append('consent1', $('input[name=rf-consent1]:checked').val() ? 1 : 0);
			data.append('consent2', $('input[name=rf-consent2]:checked').val() ? 1 : 0);
			data.append('consent3', $('input[name=rf-consent3]:checked').val() ? 1 : 0);


			data.append('language', $("#fh-language").val());
			data.append('action', 'send_unusual_form');
			data.append('nonce', ajax_var.nonce);


			$.ajax({
				type: "POST",
				url: "/wp-admin/admin-ajax.php",
				data: data,
				contentType: false,
				processData: false,

				success: function (data) {
					if (data == '1') {
						$('#rf-form .ajax-success').slideDown();
						$('#rf-form')[0].reset();
						localStorage.clear();
						$('.radios').click();
					} else {
						$('#rf-form .ajax-error-save').slideDown();
					}
				},
				error: function (data) {
					console.log('AJAX Error: ' + data.status, data.statusText);
					$('#rf-form .ajax-error-send').slideDown();
				},
				beforeSend: function () {
					$('#rf-form .ajax-loading').slideDown();
					$('#rf-form .ajax-error').slideUp();
					$('#rf-form .ajax-error-send').slideUp();
					$('#rf-form .ajax-error-save').slideUp();
					$("button#send").attr('disabled', 'disabled');
				},
				complete: function () {
					$('#rf-form .ajax-loading').slideUp();
					$("button#send").removeAttr('disabled');
				},
			});

		}

		function validatePhone(phone) {
			const re = /^[0-9+-\\(\\)\\ \\#]{1,15}$/;
			return re.test(String(phone.trim()));
		}

		function validateEmail(email) {
			const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase());
		}

		$(document).on('click', '#send', function (e) {
			e.preventDefault();
			$('.error').removeClass('error');
			$('.ajax-empty').slideUp();
			$('.ajax-success').slideUp();
			var isAllValid = true;

			if (!$('#rf-name').val() || $('#rf-name').val().length > 254) {
				$('#rf-name').parent().addClass('error');
				isAllValid = false;
			}

			if (validateEmail($('#rf-email').val()) === false || $('#rf-email').val().length > 254) {
				$('#rf-email').parent().addClass('error');
				isAllValid = false;
			}

			if (validatePhone($('#rf-phone').val()) === false || $('#rf-phone').val().length > 254) {
				$('#rf-phone').parent().addClass('error');
				isAllValid = false;
			}

			if (!$('#rf-place').val() || $('#rf-place').val().length > 254) {
				$('#rf-place').parent().addClass('error');
				isAllValid = false;
			}
			if (!$('#rf-consent1').is(':checked')) {
				$('#rf-consent1').parent().parent().addClass('error');
				isAllValid = false;
			}
			if (!$('#rf-consent2').is(':checked')) {
				$('#rf-consent2').parent().parent().addClass('error');
				isAllValid = false;
			}


			//only other

			if ($('#rf-other').is(':checked')) {
				if (!$('#rf-other-text').val() || $('#rf-other-text').val().length > 254) {
					$('#rf-other-text').parent().addClass('error');
					isAllValid = false;
				}
			}

			// organization & company & other

			if ($('#rf-company').is(':checked') || $('#rf-organization').is(':checked') || $('#rf-other').is(':checked')) {


				if (!$('#rf-companyName').val() || $('#rf-companyName').val().length > 254) {
					$('#rf-companyName').parent().addClass('error');
					isAllValid = false;
				}

				//strengthening
				if ($('#rf-enhanc').is(':checked')) {

					if (!$('#rf-eproject').val()) {
						$('#rf-eproject').parent().addClass('error');
						isAllValid = false;
					}
					if (!$('#rf-ehave').val()) {
						$('#rf-ehave').parent().addClass('error');
						isAllValid = false;
					}
					if (!$('#rf-esupport').val()) {
						$('#rf-esupport').parent().addClass('error');
						isAllValid = false;
					}
					if (!$('#rf-eidea').val()) {
						$('#rf-eidea').parent().addClass('error');
						isAllValid = false;
					}
				} else {
					$('#rf-eproject').val('');
					$('#rf-ehave').val('');
					$('#rf-esupport').val('');
					$('#rf-eidea').val('');
				}
				//new venture
				if ($('#rf-new').is(':checked')) {

					if (!$('#rf-nproject').val()) {
						$('#rf-nproject').parent().addClass('error');
						isAllValid = false;
					}
					if (!$('#rf-nhave').val()) {
						$('#rf-nhave').parent().addClass('error');
						isAllValid = false;
					}
					if (!$('#rf-nsupport').val()) {
						$('#rf-nsupport').parent().addClass('error');
						isAllValid = false;
					}
					if (!$('#rf-nidea').val()) {
						$('#rf-nidea').parent().addClass('error');
						isAllValid = false;
					}
				} else {
					$('#rf-nproject').val('');
					$('#rf-nhave').val('');
					$('#rf-nsupport').val('');
					$('#rf-nidea').val('');
				}
				//strengthening
				if ($('#rf-inst').is(':checked')) {

					if (!$('#rf-ineed').val()) {
						$('#rf-ineed').parent().addClass('error');
						isAllValid = false;
					}

				} else {
					$('#rf-ineed').val('');
				}
			}


			if (!isAllValid) {
				$('.ajax-empty').slideDown();
				return;
			}

			sendReportForm();
		});

	});
}(jQuery));